import axios from 'axios';


const instance = axios.create({
   baseURL:"https://react-my-burger1.firebaseio.com/" 
})

export default instance;